<template>
    <AuthenticatedLayout>
      <div class="users">
        <!-- Cabeçalho -->
        <header class="users-header">
          <h2>Usuários</h2>          

            <el-button type="success" @click="handleModalForm()" icon="Plus">
                Usuário
            </el-button>
        </header>
  
        <!-- Tabela de Tarefas -->
        <el-table :data="users" style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="Nome" />
          <el-table-column prop="email" label="E-mail" />
          <el-table-column prop="profile.name" label="Perfil" />
          <el-table-column label="Status">
            <template #default="{ row }">
              <StatusGeneral :status="row.status" />
            </template>
        </el-table-column>          
          <el-table-column label="Ações">
            <template #default="scope">
                <el-button type="primary" @click="editUser(scope.row)" icon="Edit" plain />
                <el-button type="danger" @click="deleteUser(scope.row)" icon="Delete" plain />                       
            </template>
          </el-table-column>
        </el-table>     
        
        <el-dialog v-model="isModalVisible" title="Cadastrar Novo Usuário">
            <el-form label-position="top" :model="userForm">

                <el-input v-model="userForm.id" disabled hidden />
                
                <el-form-item label="Nome">
                    <el-input v-model="userForm.name" />
                </el-form-item>                
                <el-form-item label="E-mail">
                    <el-input v-model="userForm.email" />
                </el-form-item>
                <el-form-item label="Senha">
                    <el-input type="password" v-model="userForm.password" show-password />
                </el-form-item>
                <el-form-item label="Confirme sua senha">
                    <el-input type="password" v-model="userForm.password_confirmation" show-password />
                </el-form-item>
                <el-form-item label="Perfil">
                    <el-select v-model="userForm.profile" placeholder="Selecione o Perfil">
                        <el-option
                            v-for="category in categories" 
                            :key="category.id"
                            :label="category.name" 
                            :value="category.id" 
                        />                        
                    </el-select>
                </el-form-item>
                <el-form-item label="Status">
                    <el-select v-model="userForm.active" placeholder="Selecione o Status">
                        <el-option label="Ativo" value="1" />
                        <el-option label="Inativo" value="0" />
                    </el-select>
                </el-form-item>

            </el-form>
            <div>
                <el-button @click="isModalVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="saveUser()">Salvar</el-button>
            </div>
        </el-dialog>

      </div>
    </AuthenticatedLayout>
  </template>
  
<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";  
import { deleteUser, getAllUsers, getCategories, storeUser, updateUser } from "@/services/userService";
import { ElMessageBox, ElNotification } from 'element-plus';
import StatusGeneral from '@/components/StatusGeneral';

export default {
name: "UsersView",
components: {
    AuthenticatedLayout,
    StatusGeneral
},
data() {
    return {
        urlApi: process.env.VUE_APP_API_URL,
        users: [],
        categories: [],
        userForm: {
            id: null,
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            profile: '',
            status: 1      
        },
        loading: false,
        isModalVisible: false 
    };
},    
methods: {
    async fetchUsers() {
        this.loading = true;
        try {
            const response = await getAllUsers();
            console.log('response ===> ', response.data)
            this.users = response.data;
        } catch (error) {
            this.$message.error("Erro ao carregar usuários.");
        } finally {
            this.loading = false;
        }
    },

    async getCategories() {
        this.loading = true;
        try {
            const response = await getCategories();                

            this.categories = response.data;
        } catch (error) {
            this.$message.error("Erro ao carregar categorias de tarefas.");
        } finally {
            this.loading = false;
        }
    },

    handleModalForm() {            
        this.isModalVisible = true;
        this.actionForm = 'create';
        this.titleModal = 'Cadastrar Usuário';
        this.resetForm();
    },

    editUser(user) {
        this.handleModalForm();

        this.userForm = {
            id: user.id,
            name: user.name,
            email: user.email,
            profile: user.profile.id,
            status: String(user.status)
        }
            
        this.titleModal = 'Atualizar Perfil';
        this.actionForm = 'update';        
    },

    async saveUser() {
        
        this.loading = true;
        this.errors = {};

        try {            
            
            if (this.actionForm == 'create') {
                await storeUser(this.userForm);

                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro criado com sucesso.',
                    type: 'success'
                });
            }

            if (this.actionForm == 'update') {
                await updateUser(this.userForm);
                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro salvo com sucesso.',
                    type: 'success'
                });
            }

            this.isModalVisible = false;
            this.resetForm();
            this.fetchUsers();

        } catch (error) {
            console.log('error ===> ', error)
            if (error.errors) {
                const errors = error.errors;
                const errorMessages = Object.values(errors)
                    .flat()
                    .join('\n');

                    ElNotification({
                        title: 'Erro de Validação',
                        message: errorMessages,
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                    });
                    this.isModalVisible = true;
            } else {
                ElNotification({
                    title: 'Erro!',
                    message: 'Ocorreu um erro inesperado ao processar a solicitação.',
                    type: 'error',
                });
            }

        } finally {                        
            this.loading = false;
        }            
    },

    async deleteUser(user){

        await ElMessageBox.confirm(
            'Deseja realmente deletar este registro: '+ user.name +'?',
            'Warning',
            {
                confirmButtonText: 'Confirmar Exclusão',
                cancelButtonText: 'Cancelar',
                type: 'warning',
            }
        )
        .then(() => {
            this.loading = true;
            
            deleteUser(user.id);                                
            this.fetchUsers();
            ElNotification({
                title: 'Atenção!',
                message: 'Registro deletado com sucesso.',
                type: 'success'
            });

        })
        .catch(() => {
            
        });

        this.fetchUsers();
        this.loading = false;
    },

    resetForm() {
        this.userForm = {
            id: null,
            name: '',
            profile: '',
            email: '',
            password: '',
            password_confirmation: '',
            status: '1'            
        }
    },
},
mounted() {
    this.fetchUsers();
    this.getCategories();
},
};
</script>

<style scoped>
.users-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.users-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
